module.exports = __webpack_public_path__ + "img/DateRange.17786fc2.svg";